const LOGOS = [
  "TESLA", "STRIPE", "SHOPIFY", "NOTION", "FIGMA", "VERCEL",
  "LINEAR", "OPENAI", "AIRBNB", "HUBSPOT", "ZAPIER", "DOORDASH",
];

export default function Marquee() {
  return (
    <section
      data-testid="logo-marquee"
      className="relative border-y border-white/5 bg-[#070708] py-7 overflow-hidden"
    >
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#070708] to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#070708] to-transparent z-10" />

      <div className="text-center text-[10px] font-mono-acc uppercase tracking-[0.32em] text-zinc-500 mb-5">
        Trusted by 120+ ambitious brands worldwide
      </div>

      <div className="flex w-[200%] marquee">
        {[...LOGOS, ...LOGOS].map((logo, i) => (
          <div
            key={i}
            className="flex-1 min-w-[180px] flex items-center justify-center"
          >
            <span className="font-clash text-xl md:text-2xl font-semibold text-zinc-500/80 tracking-tight hover:text-white transition-colors">
              {logo}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
